import {Divider, Modal, Spin, Table, Tabs} from 'antd';
import {ColumnsType} from 'antd/lib/table';
import {useAppSelector} from '../../common/hooks';
import {formatDate} from '../../utils/formatDate';
import {BATTERY_COLLECTED, BATTERY_SUBMITTED} from './swap.types';

const SwapDetail = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const state = useAppSelector((state) => state.swap);

  const submittedColumns: ColumnsType<BATTERY_SUBMITTED> = [
    {
      title: 'Battery Name',
      dataIndex: 'battery_name',
    },
    {
      title: 'Asset Id',
      dataIndex: 'battery_asset_id',
    },

    // {
    //   title: 'Capacity',
    //   dataIndex: 'battery_capacity',
    // },
    {
      title: 'Provisioned SOC(%)',
      dataIndex: 'provisioned_soc',
    },
    {
      title: 'Submitted SOC(%)',
      dataIndex: 'submitted_soc',
    },
    // {
    //   title: 'Energy Consumed',
    //   dataIndex: 'energy_consumed',
    // },
    // {
    //   title: 'Price',
    //   dataIndex: 'price',
    // },
  ];
  const collectedColumns: ColumnsType<BATTERY_COLLECTED> = [
    {
      title: 'Battery Name',
      dataIndex: 'battery_name',
    },
    {
      title: 'Asset Id',
      dataIndex: 'battery_asset_id',
    },

    // {
    //   title: 'Capacity',
    //   dataIndex: 'battery_capacity',
    // },
    {
      title: 'Provisioned SOC(%)',
      dataIndex: 'provisioned_soc',
    },
  ];

  const tabs = [
    {
      label: `Submitted Batteries`,
      key: '1',
      children: (
        <Table
          rowKey='battery_asset_id'
          columns={submittedColumns}
          loading={state.isLoading}
          pagination={false}
          size='middle'
          dataSource={state.swapDetail.submitted_batteries}
        />
      ),
    },
    {
      label: `Collected Batteries`,
      key: '2',
      children: (
        <Table
          rowKey='battery_asset_id'
          columns={collectedColumns}
          pagination={false}
          loading={state.isLoading}
          size='middle'
          dataSource={state.swapDetail.provisioned_batteries}
        />
      ),
    },
  ];

  if (
    state.swapDetail.swap_type === 'customer_assign' ||
    state.swapDetail.swap_type === 'internal_remove'
  ) {
    tabs.splice(0, 1);
  } else if (state.swapDetail.swap_type === 'internal_add') {
    tabs.splice(1, 1);
  }
  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      width={800}
      title={`Swap Details ( ${state.swapDetail.swap_type})`}
      footer={null}
    >
      <Spin spinning={state.isLoading}>
        <div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div>
              {state.swapDetail.swap_type === 'normal' ||
              state.swapDetail.swap_type === 'customer_assign' ? (
                <h3>Customer name : {state.swapDetail.customer_name}</h3>
              ) : null}
              <h3>
                Total Batteries :
                {state.swapDetail.submitted_batteries.length ||
                  state.swapDetail.provisioned_batteries.length}
              </h3>
            </div>
            <div>
              <h3>Time : {formatDate(state.swapDetail.created_at)}</h3>
              {state.swapDetail.swap_type === 'normal' && (
                <h3> Total Price : {state.swapDetail.total_price}</h3>
              )}
            </div>
          </div>

          <Divider style={{borderColor: 'black'}} />
          <Tabs defaultActiveKey='1' items={tabs} />
          {state.swapDetail.swap_type === 'normal' && (
            <>
              <Divider style={{borderColor: 'black'}} />

              {/* <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                  <h5>Billing Strategy : {state.swapDetail.billing_config.billingStrategy}</h5>
                  {state.swapDetail.billing_config.billingStrategy ===
                    billingStrategy.SOC_BASED && (
                    <h5>Total Price : Total Energy Conumed * Energ Unit Price</h5>
                  )}
                  {state.swapDetail.billing_config.billingStrategy === billingStrategy.FLAT && (
                    <h5>Total Price : Flat Prce</h5>
                  )}
                  {state.swapDetail.billing_config.billingStrategy ===
                    billingStrategy.FLAT_EXTENDED && (
                    <h5>Total Price : Flat Price + Total Energy Conumed * Energ Unit Price</h5>
                  )}
                </div>
                <div>
                  {state.swapDetail.billing_config.billingStrategy !==
                    billingStrategy.SOC_BASED && (
                    <h5>Flat Price : {state.swapDetail.billing_config.flatPrice}</h5>
                  )}
                  {state.swapDetail.billing_config.billingStrategy !== billingStrategy.FLAT && (
                    <h5>Energy Unit Price: {state.swapDetail.billing_config.energyUnitPrice}</h5>
                  )}
                </div>
              </div> */}
            </>
          )}
        </div>
      </Spin>
    </Modal>
  );
};

export default SwapDetail;
